import { getOrdersQuery } from '@/api/orders/orderQueries';
import BackButton from '@/components/common/BackButton';
import { Heading } from '@/components/common/Heading';
import { Pagination } from '@/components/common/Pagination';
import { Section } from '@/components/common/Section';
import { Spinner } from '@/components/common/Spinner';
import {
  Card,
  CardContent,
  CardsContainer,
} from '@/components/dashboard/DashboardCard';
import { OrderCard } from '@/components/dashboard/my-orders/OrderCard';
import { routes } from '@/routes/routes';
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';

export const MyOrdersPage = () => {
  const [page, setPage] = useState(1);

  const {
    data: ordersData,
    isLoading,
    isPlaceholderData,
  } = useQuery(getOrdersQuery(page));

  const orders = ordersData?.data || [];
  const meta = ordersData?.meta;

  return (
    <Section>
      <BackButton to={routes.dashboard.index} className="mb-4">
        Go back
      </BackButton>

      <Heading as="h1" size="h3" className="text-secondary mb-7 text-left">
        Order History
      </Heading>

      {isLoading ? (
        <Card className="flex min-h-40 w-full items-center justify-center">
          <Spinner className="size-10" />
        </Card>
      ) : (
        <>
          <CardsContainer className="-mx-4 lg:mx-0">
            {orders.length === 0 ? (
              <Card>
                <CardContent className="flex min-h-40 items-center justify-center">
                  <p className="text-muted-foreground text-lg">
                    No active orders yet
                  </p>
                </CardContent>
              </Card>
            ) : (
              <>
                {orders.map((order) => (
                  <OrderCard key={order.id} order={order} />
                ))}
              </>
            )}
          </CardsContainer>

          {meta && (
            <Pagination
              currentPage={meta.current_page}
              lastPage={meta.last_page}
              total={meta.total}
              perPage={meta.per_page}
              onPageChange={setPage}
              isLoading={isPlaceholderData}
            />
          )}
        </>
      )}
    </Section>
  );
};
